import {h} from 'preact'
import css from 'minify-css.macro'
import {Box} from '@dash-ui/react-layout'
import {styles} from '../styles'
import type {DashLibraries} from '../types'
import type {BoxProps} from '@dash-ui/react-layout'

export const BuildBadges: React.FC<BuildBadgesProps> = ({
  library = 'styles',
}) => (
  <Box className={buildBadges()}>
    <a
      className={badge()}
      href={`https://bundlephobia.com/result?p=@dash-ui/${library}`}
      rel='nofollow noopener noreferrer'
      target='_blank'
    >
      <img
        alt='Bundlephobia'
        src={`https://img.shields.io/bundlephobia/minzip/@dash-ui/${library}?style=for-the-badge&labelColor=24292e`}
      />
    </a>
    <a
      className={badge()}
      href={`https://www.npmjs.com/package/@dash-ui/${library}`}
      rel='noopener noreferrer'
      target='_blank'
    >
      <img
        alt='Types'
        src={`https://img.shields.io/npm/types/@dash-ui/${library}?style=for-the-badge&labelColor=24292e`}
      />
    </a>
    <a
      className={badge()}
      href={`https://codecov.io/gh/dash-ui/${library}`}
      rel='noopener noreferrer'
      target='_blank'
    >
      <img
        alt='Code coverage'
        src={`https://img.shields.io/codecov/c/gh/dash-ui/${library}?style=for-the-badge&labelColor=24292e`}
      />
    </a>
    <a
      className={badge()}
      href={`https://travis-ci.com/dash-ui/${library}`}
      rel='nofollow noopener noreferrer'
      target='_blank'
    >
      <img
        alt='Build status'
        src={`https://img.shields.io/travis/com/dash-ui/${library}?style=for-the-badge&labelColor=24292e`}
      />
    </a>
    <a
      className={badge()}
      href={`https://www.npmjs.com/package/@dash-ui/${library}`}
      rel='noopener noreferrer'
      target='_blank'
    >
      <img
        alt='NPM Version'
        src={`https://img.shields.io/npm/v/@dash-ui/${library}?style=for-the-badge&labelColor=24292e`}
      />
    </a>
    <a
      className={badge()}
      href='https://jaredlunde.mit-license.org/'
      rel='nofollow noopener noreferrer'
      target='_blank'
    >
      <img
        alt='MIT License'
        src={`https://img.shields.io/npm/l/@dash-ui/${library}?style=for-the-badge&labelColor=24292e`}
      />
    </a>
  </Box>
)

const badge = styles.one(
  ({radius}) => css`
    border-radius: ${radius.max};
    overflow: hidden;
    height: 24px;

    img {
      height: 100%;
      max-height: 100%;
    }
  `
)

export interface BuildBadgesProps extends BoxProps {
  library?: DashLibraries
}

const buildBadges = styles.one(
  ({gap, pad}) => css`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: calc(-1 * ${gap.md});
    margin-left: calc(-1 * ${gap.md});
    padding: ${pad.lg};

    > * {
      margin-top: ${gap.md};
      margin-left: ${gap.md};
    }
  `
)
